import { Button, type IButtonProps } from '~/components/button'

type ButtonBackProps = Omit<IButtonProps, 'children'> & {
  testID?: string
}

export function ButtonBack(props: ButtonBackProps) {
  return (
    <Button.Root
      {...props}
      size={props.size || 'md'}
      variant="neutral-tertiary"
    >
      <Button.Icon symbol="rdicon-chevron-left" />
    </Button.Root>
  )
}
